<template>
    <div class="publicMobile">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" @click="goto('PublicNumberList')">公众号管理</el-menu-item>
            <el-menu-item index="2" @click="goto('PublicMobile')">模版消息管理</el-menu-item>
            <el-menu-item index="3" @click="goto('MessagePush')">推送消息管理</el-menu-item>
        </el-menu>

        <div>
            <el-button type="primary" class="add" @click="dialogVisible = true">同步模版消息</el-button>
           <div class="search">
               <el-select v-model="value" placeholder="请选择">
                   <el-option
                       v-for="item in options"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
                   </el-option>
               </el-select>
               <el-button type="primary" @click="search()">搜索</el-button>
           </div>
        </div>

        <el-table :data="tableData" class="publicMobile-table">
            <!--<el-table-column type="selection" width="55px"></el-table-column>-->
            <el-table-column prop="name" label="模版名称" align="left"></el-table-column>
            <el-table-column prop="wxtemplateid" label="模版编号" align="center" width="400"></el-table-column>
            <el-table-column prop="industryname" label="行业" align="center"></el-table-column>
            <el-table-column prop="content" label="模版内容" align="center" width="400"></el-table-column>
            <el-table-column label="操作" align="right" width="100">
                <template slot-scope="scope">
                    <div class="publicMobile-position">
                        <el-button type="text" size="small" @click="goto('PublicMobileInfo',scope.row.innerid)">查看</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="rowCount" align="center" @current-change="fPage()" :current-page.sync="currentPage">
        </el-pagination>

        <el-dialog
            title="选择同步公众号"
            :visible.sync="dialogVisible"
            width="600px">

            <el-select v-model="dlgOptionsValue" placeholder="选择公众号" width="320px">
                <el-option
                    v-for="item in dlgOptions"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
            </el-select>
            <p style="margin-top: 10px;color: red">友情提示：只有认证的公众号才能同步模板消息！</p>

            <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="mobile()">确 定</el-button>
        </span>
        </el-dialog>

    </div>
</template>

<script>
    import {findMpmessageTemplateList, syncTmplMsg, findMpaccountList, findAllMpaccount} from '@/api/accountApi'
    import Loading from 'base/loading/loading'    // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'PublicNumberList',
        data() {
            return {
                activeIndex: '2',
                dialogVisible: false,
                options: [],
                dlgOptions: [],
                dlgOptionsValue: '',
                value: '',
                token: JSON.parse(sessionStorage['user']).loginToken, // token
                shopID: JSON.parse(sessionStorage['shop']).ShopID, // 店铺id
                sessionUser: JSON.parse(sessionStorage['user']), // 用户信息
                // innerid: this.$route.query.innerid,
                // thdcode: this.$route.query.thdcode,
                // appid: this.$route.query.appid,
                tableData: [],  // 表单数据
                currentPage: 1,     // 初始化页数
                page: 1,            // 页数
                rowCount: 0,        // 数据条数
                apiData: {}         // api数据
            }
        },
        mounted() {
            this.datalist()
            this.selectData() // 下拉菜单列表数据
        },
        methods: {
            goto(href,innerid) {
                this.$router.push({name: href,query:{'innerid':innerid}})
            },
            fPage() {
                let clickPage = $(".el-pagination .active").html()
                // this.apiData.page = clickPage
                // 调用模版列表
                this.datalist(clickPage)
            },
            selectData() {

                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3
                    // page: this.page,
                    // pageSize: 10
                }

                this.setLoading(true)
                // 公众号列表
                findAllMpaccount({
                    data: data,
                    success:data => {
                        this.setLoading(false)
                        // console.log(data)
                        // data.data.mpaccountlist.unshift({paname:'全部',code:''})
                        this.dlgOptions = JSON.parse(JSON.stringify(data.data))
                        this.options = data.data
                        this.options.unshift({name:'全部',code:''})
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            },
            datalist(page) {
                this.setLoading(true)
                // 模版列表
                if (page) {
                    this.page = page
                }

                this.apiData = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3,
                    code: this.value,
                    type: 0,
                    page: this.page,
                    pageSize: 10
                }


                // 搜索数据为空时 默认搜索全部数据
                if (this.value === '') {
                    this.apiData.type = 0   // 搜索全部
                } else {
                    this.apiData.type = 1   // 根据关键词搜索
                }

                findMpmessageTemplateList({
                    data: this.apiData,
                    success:data => {
                        this.setLoading(false)
                        console.log(data)
                        this.tableData = data.data.content
                        this.rowCount = data.data.splitPage.rowCount
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            },
            mobile() {
                // 同步公众号
                // if (this.dlgOptionsValue.length > 0) {
                //
                //
                // } else {
                //     this.$message.error('请选择公众号')
                // }
                var data = {
                    // LoginToken: this.token,
                    // ShopID: this.shopID,
                    ClientType: 3,
                    code: this.dlgOptionsValue
                }

                this.setLoading(true)
                syncTmplMsg({
                    data: data,
                    success:data => {
                        console.log(data)
                        this.setLoading(false)
                        if(data.data.errorCode === '00') {
                            this.$message.success('同步成功')
                            this.datalist(1)
                            this.dialogVisible = true
                        } else {
                            this.$message.error('同步失败')
                        }
                    },
                    error:data => {
                        this.setLoading(false)
                        console.log(data)
                    }
                })

            },
            search() {
                // 公众号搜索
                this.datalist(1)
                // if (this.value === '') {
                //     this.$message.error('请选择公众号')
                // } else {
                //     // 调用查询接口
                //
                // }

            },
            selecList(data,json) {
                // 遍历数组

                for (var i = 0; i < json.length; i++){
                    if (data === json[i].innerid) {
                        return json[i]
                    }
                }
            },
            ...mapActions ([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {Loading}
    }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .publicMobile {
        .el-input__icon {
            line-height: normal;
        }
        .header {
            border-left: solid 2px #409EFF;
            h1 {
                margin-left: 8px;
                color: #303133;
                font-size: 16px;
                font-weight: bold;
            }
        }
        .add {
            margin-top: 20px;
            width:138px;
            height:36px;
        }
        span {
            font-size: 14px;
        }
        img {
            float:left;
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
        .publicMobile-table {
            width:100%;
            /*min-height: 640px;*/
            text-align:center;
            margin-top: 30px;

            .publicMobile-name {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: start;
                -ms-flex-pack: start;
                justify-content: flex-start;

                p {
                    padding-left: 10px;
                }


            }

            .publicMobile-position {
                .el-button {
                    min-width: auto;
                }
                i {
                    margin: 0 10px;
                    color: #409EFF;
                }
            }
        }


        .el-pagination {
            margin-top: 20px
        }

        .search {
            float: right;
            margin-top: 20px;

            .el-button {
                margin-left: 20px;
                height: 36px;
            }
            .el-input, .el-input--mini, .el-input--mini .el-input__inner, .el-input__inner {
                height: 36px;
            }
            .el-input__icon {
                line-height: 36px;
            }
        }
        .el-dialog {
            .el-dialog__body {
                text-align: center;
            }
            .el-select {
                width: 330px;
            }
        }
    }
</style>
